import { render, staticRenderFns } from "./contractDetail.vue?vue&type=template&id=25d33e2f&scoped=true"
import script from "./contractDetail.vue?vue&type=script&lang=js"
export * from "./contractDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d33e2f",
  null
  
)

export default component.exports